import { useMemo } from "react";

function mulberry32(a) {
    return function () {
        a |= 0;
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

export default function Starfield({ density = 70 }) {
    const stars = useMemo(() => {
        const rand = mulberry32(42);
        return Array.from({ length: density }, (_, i) => ({
            id: i,
            x: rand() * 100,
            y: rand() * 100,
            size: rand() < 0.85 ? 1 : 2,
            delay: rand() * 6,
            dur: 3 + rand() * 4,
            blue: rand() < 0.3,
        }));
    }, [density]);

    return (
        <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 overflow-hidden"
        >
            {stars.map((s) => (
                <span
                    key={s.id}
                    className={`twinkle absolute rounded-full ${
                        s.blue ? "bg-celestial-blue" : "bg-white"
                    }`}
                    style={{
                        left: `${s.x}%`,
                        top: `${s.y}%`,
                        width: s.size,
                        height: s.size,
                        opacity: 0.7,
                        animationDuration: `${s.dur}s`,
                        animationDelay: `${s.delay}s`,
                    }}
                />
            ))}
            <div className="absolute -left-24 -top-32 h-96 w-96 rounded-full bg-celestial-blue/10 blur-[120px]" />
            <div className="absolute -bottom-10 right-0 h-80 w-80 rounded-full bg-celestial-gold/10 blur-[120px]" />
        </div>
    );
}
